var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfits(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-164 42.3 512 512",
    style: {
      enableBackground: "new -164 42.3 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#843B90;}\n\t.st1{fill:#7ED5C5;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M182.7,522.3c0,5.9-4.8,10.7-10.7,10.7h-298.7c-5.9,0-10.7-4.8-10.7-10.7V159.6h64c17.7,0,32-14.3,32-32v-64 H172c5.9,0,10.7,4.8,10.7,10.7v213.3H204V74.3c0-17.7-14.3-32-32-32H-52c-0.6,0-1.1,0.1-1.7,0.1c-0.1,0-0.2,0-0.4,0.1 c-0.2,0-0.3,0.1-0.5,0.1c-0.2,0-0.4,0.1-0.5,0.1c-0.1,0-0.2,0.1-0.3,0.1c-0.2,0.1-0.4,0.1-0.6,0.2c-0.1,0-0.2,0.1-0.3,0.1 c-0.2,0.1-0.5,0.2-0.7,0.3c-0.1,0-0.2,0.1-0.2,0.1c-0.2,0.1-0.4,0.3-0.7,0.4c-0.1,0.1-0.2,0.2-0.3,0.2c-0.2,0.1-0.3,0.2-0.5,0.4 c-0.3,0.2-0.5,0.5-0.8,0.7l-96,96c-2,2-3.1,4.7-3.1,7.5v373.3c0,17.7,14.3,32,32,32H172c17.7,0,32-14.3,32-32v-21.3h-21.3V522.3z  M-62.7,127.6c0,5.9-4.8,10.7-10.7,10.7h-48.9l59.6-59.6V127.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M332,458.3V276.9c0-5.9-4.8-10.7-10.7-10.7h-64c-5.9,0-10.7,4.8-10.7,10.7v181.3h-32V319.6 c0-5.9-4.8-10.7-10.7-10.7h-64c-5.9,0-10.7,4.8-10.7,10.7v138.7h-32v-96c0-5.9-4.8-10.7-10.7-10.7h-64c-5.9,0-10.7,4.8-10.7,10.7 v96h-42.7v21.3h53.3h64H140h64h53.3h64h21.3v-21.3H332z M33.3,458.3v-85.3H76v85.3H33.3z M150.7,458.3v-128h42.7v128H150.7z  M268,458.3V287.6h42.7v170.7H268z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -73.3,
    y: 458.3,
    className: "st1",
    width: 21.3,
    height: 21.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-41.3,234.3c0,53,43,96,96,96c53-0.1,95.9-43,96-96c0-53-43-96-96-96C1.6,138.3-41.3,181.3-41.3,234.3z  M129.3,234.3c0,41.2-33.4,74.7-74.7,74.7c-41.2,0-74.7-33.4-74.7-74.7s33.4-74.7,74.7-74.7C95.9,159.7,129.3,193.1,129.3,234.3z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44,170.3v12.5c-12.4,4.4-21.3,16.2-21.3,30.2c0,17.7,14.3,32,32,32c5.9,0,10.7,4.8,10.7,10.7 c0,5.9-4.8,10.7-10.7,10.7c-5.9,0-10.7-4.8-10.7-10.7H22.7c0,13.9,8.9,25.8,21.3,30.2v12.5h21.3v-12.5 c12.4-4.4,21.3-16.2,21.3-30.2c0-17.7-14.3-32-32-32c-5.9,0-10.7-4.8-10.7-10.7c0-5.9,4.8-10.7,10.7-10.7 c5.9,0,10.7,4.8,10.7,10.7h21.3c0-13.9-8.9-25.8-21.3-30.2v-12.5H44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M161.3,95.6c0-5.9-4.8-10.7-10.7-10.7H108v21.3h32v32h21.3V95.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.3,
    y: 84.9,
    className: "st0",
    width: 21.3,
    height: 21.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -116,
    y: 458.3,
    className: "st1",
    width: 21.3,
    height: 21.3
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfits);
export default __webpack_public_path__ + "static/media/profits.3e27ccc644bac93ba9b458a28cec5359.svg";
export { ForwardRef as ReactComponent };